<template>
    <div class="home pure-g">
        
        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
    
            <div class="menuBarBox">
                <div class="pure-menu pure-menu-horizontal menuBar">
                    <li id="menuCancel" class="pure-menu-item"><router-link class="pure-menu-link" to="/customers" >Abbrechen</router-link></li>
                    <li id="menuSave" class="pure-menu-item"><a v-on:click="save" class="pure-menu-link" >Speichern</a></li>
                </div>
            </div>
    
            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Kunde bearbeiten</legend>

                        <div class="pure-g">
                            <div class="pure-u-1-1">
                                <label for="account">Name</label>
                                <input id="account" class="pure-u-10-24" type="text" v-model="name">
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="comment">Bemerkungen</label>
                                <textarea id="comment" class="pure-u-10-24 comment" v-model="comment">
                                </textarea>
                            </div>
                        </div>
                    
                        <legend>Module</legend>
                        <div class="pure-g">
                            <div class="pure-u-1-1">
                        
                                <module-list :modules="modules" :customer-url="customerUrl"/>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import axios from "axios"
import router from '@/router.js'
import ModuleList from '@/components/ModuleList.vue'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'


export default {
  name: 'editCustomerView',
  data: function () {
      return {
        customerUrl: null,
        name: null,
        comment: null,
        modules: []
      }
  },
  components: {
    MainMenu,
    ModuleList
  },
  mounted: function() {

    this.customerUrl = this.$route.params.url
    this.loadData(this.$route.params.url)
  },
  methods: {

    loadData: function(url) {
      
      axios(
        { 
            method: 'GET', 
            'url': url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getJwt()
            }
        })
        .then(
            result => {                
                console.log(result.data)

                this.name = result.data.name
                this.comment = result.data.comment
                //this.modulesUrl = result.data._links.modules.href

                this.loadModules(result.data._links.modules.href)
            },
            error => {
                console.error(error)
            }
      )
    },

    loadModules: function(modulesUrl) {

       axios(
        { 
            method: 'GET', 
            'url': modulesUrl,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getJwt()
            }
        })
        .then(
            result => {                
                console.log(result.data)

                this.modules = result.data.data
            },
            error => {
                console.error(error)
            }
      ) 
    },

    save: function(doReturn) {

        if (this.password !== this.passwordCheck) {

            toastError('Die Passwörter stimmen nicht überein!')
            return
        }

        axios({ 
            method: 'PUT', 
            'url': this.$route.params.url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getJwt()
            },
            data: {
                name: this.name,
                comment: this.comment
            }
        })
        .then(
            result => {
                toastInfo('Der Benutzer wurde aktualisiert.')

                if (doReturn) {
                    router.push({ name: 'customerView' })
                } else {
                    this.clear()
                }
            },
            error => {
                toastError(error.response.data.message)
            }
        )
    }
  }
}
</script>

<style>

#language {
    width: 200px;
}

</style>